import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConnectionTypeModel } from 'src/app/Model/ConnectionType.model';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { ConnectionTypeService } from 'src/app/Services/connection-type/ConnectionType.service';

@Component({
  selector: 'app-header2',
  templateUrl: './header2.component.html',
  styleUrls: ['./header2.component.css']
})
export class Header2Component implements OnInit {

 
  @Input() type: string = null;
  @Input() url: string = null;
  @Input() queryparams: any = null;
  public hidenav:boolean = true;
  public lang
  public activeLang = 'es';
  public name_type_connection = '';
  data: ConnectionTypeModel
  drawer : any;
  Languages: any[] = [
    {Id:"es",Name:"Español"},
    {Id:"en",Name:"English"},
    {Id:"pt",Name:"Português"}
  ];
  
  constructor(
    private readonly translate: TranslateService, 
    private readonly Service: ConnectionTypeService,
    private readonly activeRoute: ActivatedRoute,
    private readonly lsService : SessionStorageService
    ) {

    this.lang = this.lsService.getLSItem('language')
    this.translate.setDefaultLang(this.lang);
    
   }

  async ngOnInit() {
    
    this.activeRoute.queryParams.subscribe((param) => {
      if (param.lang == undefined) {

        if (this.lsService.getLSItem('language') == null) {
          
          this.lsService.setLSItem('language',this.activeLang)
          this.lang = this.lsService.getLSItem('language')
          this.translate.setDefaultLang(this.lang);
  
        }
        
      }
      else
      {
        this.lsService.setLSItem('language',param.lang)
        this.lang = this.lsService.getLSItem('language')
        this.translate.setDefaultLang(this.lang);
      }
    });


    if (this.type == null) {
      this.type = this.lsService.getLSItem('type')
    }
    if (this.type != null) {
      this.data = new ConnectionTypeModel();
      this.data.Id = +this.type
      await this.Service.getIdConnectionType(this.data).then(res => {

        this.name_type_connection = res.Name;

      });
    }
  }

  /**
   * changeLanguage
   */
   public changeLanguage(lang) {
     this.translate.setDefaultLang(lang.value);
     this.lsService.setLSItem('language',lang.value)
  }


}

